import React, { useEffect, useState } from 'react';
import { useQuery, useMutation, useLazyQuery } from '@apollo/client';
import { DeleteOutlined } from '@ant-design/icons';
import { Typography, Row, Col } from 'antd';
import { DocumentsCard, MessagesCardDashboard, UsersTable } from '../components';
import { IDocuments, IDocumentsTypes, IMessages } from '../interfaces';
import { GET_UNREAD_CHANNELS, GET_CLIENT_DOCUMENTS, GET_DOCUMENTS_TYPES, CLEAR_NOTIFICATIONS } from '../graphql';
import { getToken } from '../services';

const { Title, Text } = Typography;
type DashboardProps = {
    isAdmin: boolean;
};

function Dashboard({ isAdmin }: DashboardProps): React.ReactElement {
    const [messages, setMessages] = useState<IMessages[]>([]);
    const [documents, setDocuments] = useState<IDocuments[]>([]);
    const [documentTypes, setDocumentTypes] = useState<IDocumentsTypes[]>([]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const {
        loading: channelsLoading,
        data: channelsData,
        refetch: refetchChannelsData,
    } = useQuery(GET_UNREAD_CHANNELS, {
        variables: { count: 5, status: 'SENT' },
        fetchPolicy: 'network-only',
    });

    const [clearNotifications] = useMutation(CLEAR_NOTIFICATIONS);

    const [getDocuments, { loading: documentsLoading, data: documentsData }] = useLazyQuery(GET_CLIENT_DOCUMENTS, {
        variables: { clientId: getToken()?.user?.id },
        fetchPolicy: 'network-only',
    });

    const [getDocumentTypes, { loading: documentTypesLoading, data: documentTypesData }] = useLazyQuery(
        GET_DOCUMENTS_TYPES,
        {
            variables: {clientId: getToken()?.user?.id},
            fetchPolicy: 'network-only',
        },
    );

    const handleClearNotifications = () => {
        clearNotifications({
            variables: { fromId: 'x' },
        })
            .then(() => {
                refetchChannelsData()
                    .then(() => {})
                    .catch(() => {});
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-argument
        if (channelsData?.getUnreadChannels) {
            setMessages(channelsData.getUnreadChannels.messages);
        }
    }, [channelsData]);

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-argument
        if (documentsData?.getClientDocuments) setDocuments(documentsData.getClientDocuments);
        if (documentTypesData?.getDocumentTypes) {
            setDocumentTypes(JSON.parse(documentTypesData?.getDocumentTypes));
        }
    }, [documentsData, documentTypesData]);

    useEffect(() => {
        getDocuments();
        getDocumentTypes();
    }, []);

    return (
        <div>
            <div
                style={{
                    padding: '7px',
                    marginLeft: '5px',
                    marginRight: '5px',
                    marginBottom: '10px',
                    background: '#ffffff',
                    borderRadius: '15px',
                }}
            >
                <Row>
                    <Col span="18">
                        <Row>
                            <Col span="24" style={{ paddingLeft: '10px', paddingTop: '10px' }}>
                                <Text className="card-heading">Message Notifications</Text>
                            </Col>
                            <Col span="24" style={{ marginTop: '-27px', paddingLeft: '10px' }}>
                                <Text style={{ fontWeight: 'bold', fontSize: '20px', color: '#EE773B' }}>___</Text>
                            </Col>
                        </Row>
                    </Col>
                    <Col span="6" style={{ textAlign: 'right' }}>
                        {messages.length > 0 && (
                            <DeleteOutlined onClick={() => handleClearNotifications()} className="hoverable-icon" />
                        )}
                    </Col>
                </Row>
                <MessagesCardDashboard messages={messages} loading={channelsLoading} />
            </div>
            {isAdmin ? (
                <UsersTable roleId="CLIENT" title="User Accounts" />
            ) : (
                <DocumentsCard
                    documents={documents}
                    documentTypes={documentTypes}
                    loading={documentsLoading}
                    isAdmin={false}
                    getDocuments={getDocuments}
                />
            )}
        </div>
    );
}

export default Dashboard;
